import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createUser, usersQueryKeys } from '@api/users';

export function useCreateUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createUser,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: usersQueryKeys.lists() });
    },
  });
}
